__turbopack_context__.v({
  "description": "StateMessage-module-scss-module__z7XO4q__description",
  "link": "StateMessage-module-scss-module__z7XO4q__link",
  "primaryButton": "StateMessage-module-scss-module__z7XO4q__primaryButton",
  "root": "StateMessage-module-scss-module__z7XO4q__root",
  "title": "StateMessage-module-scss-module__z7XO4q__title",
});
